import { Center, Paper, Stack, Text, Title } from "@mantine/core";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

/** Rámeček veřejných obrazovek (přihlášení, nastavení hesla). */
export function AuthCard({ title, children }: { title: string; children: ReactNode }) {
  const { t } = useTranslation();
  return (
    <Center mih="100vh" p="md" bg="var(--mantine-color-gray-0)">
      <Paper withBorder shadow="sm" p="lg" w="100%" maw={420}>
        <Stack>
          <Text fw={700} size="xl" c="blue.7">
            {t("app.name")}
          </Text>
          <Title order={2}>{title}</Title>
          {children}
        </Stack>
      </Paper>
    </Center>
  );
}
